<template>
    <div class="group">
        <HeaderReturn title="我的团队"></HeaderReturn>
        <div class="property">
            <p>我的邀请码：{{ inviteCode }}</p>

            <!-- performanceList -->
            <div class="group_grid">
                <div>
                    认购团队总业绩(USDT)：<span>{{ sumReduce }}</span>
                </div>
                <div>
                    认购大区业绩(USDT)： <span>{{ maxReduce }}</span>
                </div>
                <div>
                    认购小区业绩(USDT)： <span>{{ minReduce }}</span>
                </div>
            </div>

        </div>

        <div class="group_ul">
            <ul>
                
                <li v-for="(item, index) in AccasetList" :key="item.id">
                    <div class="d-flex justify-between">
                        <p class="d-flex my_flex">
                            <!-- <img src="../../assets/img//tabar/wode-off.png" alt=""> -->
                            <img src="../../assets/img/tabar/examine.png" />
                            {{ item.userId }}

                        </p>
                        <!-- <p>
                            {{ item.type == 1 ? '有效' : '无效' }}
                        </p> -->
                    </div>
                    <div>
                        <p>{{ item.my }}</p>
                        <p>{{ item.team }}</p>
                    </div>
                    <div>
                        <p>个人认购业绩(USDT)</p>
                        <p>团队认购业绩(USDT)</p>
                    </div>
                </li>
            </ul>
        </div>





    </div>
</template>
<script>
import Vue from 'vue';
import { NoticeBar, Icon } from 'vant';
Vue.use(NoticeBar).use(Icon);
import vueQr from "vue-qr";
import {
    mainApiData
} from '@/request/api.js'
export default {
    components: {
        vueQr,
    },
    data() {
        return {
            baseApi: "",
            UrlYqhy: "",
            Aeccter: {
                money: 75.8193,

            },
            TeamList: [
                {
                    url: require('../../assets/img/page/mm.png'),
                    txt: "充值",
                    id: 0,
                    path: '/My/recharge'
                },
                {
                    url: require('../../assets/img/page/aq.png'),
                    txt: "提币",
                    id: 1,
                    path: '/My/withdrawal'

                },
                {
                    url: require('../../assets/img/page/bf.png'),
                    txt: "闪兑",
                    id: 2,
                    path: "/My/flashExchange"
                }
            ],
            AccasetList: [],
            performanceList: {
                total: 99999,
                region: 77777,
                plot: 33333
            },
            inviteCode: '',
            maxReduce: 0,
            minReduce: 0,
            sumReduce:0


        }
    },
    created() {
        this.baseApi = process.env.VUE_APP_IMG;
        this.inviteCode = JSON.parse(sessionStorage.getItem('ms_user')).user.inviteCode;
        this.UrlYqhy = window.location.origin + '/#/reg?promotion=' + '1111';
        this.Init()
    },
    methods: {
        Init() {
            mainApiData.myTeam().then((res) => {
                if (res.data.code == 200) {
                   this.maxReduce=res.data.data.maxReduce;//大区
                   this.minReduce=res.data.data.minReduce;//小区
                   this.sumReduce=res.data.data.sumReduce;//总
                   this.AccasetList=res.data.data.list;
                }
            });
        },
        onCopy() {
            this.$toast(this.$t('myself.a23'))
        },
        goLink(path, item) {
            if (path) {
                this.$router.push({
                    path,
                    query: {
                        item: JSON.stringify(item),
                    }
                });
            } else {
                // 暂未开放
                this.$toast(this.$t('orePond.a42'));
            }
        }

    }
}
</script>
<style lang="scss" scoped="scoped">
// 引入全局的样式
@import "@/assets/scss/base.scss";
::v-deep .my_flex{
    display: flex;
    align-items: center;
}
::v-deep .van-nav-bar__title {
  color: #f89b19 !important;
  font-size: 20px;
  font-weight: 600;
}
.group {
    margin: 50px 10px;

    ::v-deep .van-nav-bar__title {
        color: #fff;
    }

    .property {
        // width: 90%;
        margin: 15px 10px;
        padding: 5px 5px 10px 10px;
        // height: 158px;

        background: url(../../assets/img/page/ZC-345X180.png) no-repeat;
        background-size: 100% 100%;

        ::v-deep .number-grow {
            color: #fff !important;
            font-size: 20px;
        }

        ::v-deep .number-grows {
            color: #fff !important;
            font-size: 16px;
            margin-top: 3px;
            display: block;
        }

        p {
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            /* identical to box height */
            color: var(--unnamed, #915E20);

            /* 白/FE */

            // color: #FEFEFE;

            &:nth-child(1) {
                padding: 20px 10px 0 10px;
                font-family: 'PingFang SC';
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                /* identical to box height */
                text-align: left;
                margin-bottom: 10px;
                // color: #915E20;


                // ::v-deep .numsp {

                //     font-size: 15px !important;
                //     border: 1px solid red;
                // }
            }

            span {
                color: #915E20;
                font-size: 18px;
            }

            &:nth-child(2) {
                padding: 5px 10px 0 10px;


            }

            .numsp {

                // font-size: 20px !important;
                // border: 1px solid red;
            }
        }

    }

    .group_grid {

        div {
            display: flex;
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            padding: 5px 10px;

            color: #915E20;

            span {
                font-weight: 500;
                font-size: 14px;
                line-height: 20px;

                color: #915E20;

            }

            &:nth-child(3) {
                padding-bottom: 15px;
            }

        }
    }

    .group_ul {
        overflow: hidden;
        overflow-y: scroll;
        height: 530px;
   
        ul {
            li {
                margin: 20px 10px;
                // background: rgba(20, 132, 195, 0.2);
                /* 黄/主题 */

                border: 0.5px solid #f89b19;
                // box-shadow: 0px 0px 6px 2px rgba(20, 132, 195, 0.25), inset 0px 0px 6px -2px rgba(20, 132, 195, 0.25);
                border-radius: 4px;

                div {
                    img {
                        width: 20px;
                        height: 20px;
                        margin-right: 3px;
                    }

                    &:nth-child(1) {
                        padding: 10px 15px;

                        p {
                            font-style: normal;
                            font-weight: 400;
                            line-height: 25px;
                            text-align: center;

                            // color: #FFFFFF;

                            color: var(--unnamed, #f89b19);
font-size: 14px;


                            &:nth-child(1) {

                                font-family: 'PingFang SC';
                                font-style: normal;
                                font-weight: 400;
                                line-height: 25px;
                                text-align: center;

                                // color: #FFFFFF;

                            }

                            &:nth-child(2) {
                                box-shadow: 0 0 0 0.5px #14C44F; //实现0.5px四周线
                                font-family: 'PingFang SC';
                                font-style: normal;
                                padding: 5px 10px;
                                border-radius: 4px;
                                font-weight: 400;
                                font-size: 12px;
                                line-height: 17px;
                                /* identical to box height */

                                text-align: center;

                                color: #14C44F;
                            }


                        }
                    }

                    &:nth-child(2),
                    &:nth-child(3) {
                        display: flex;
                        justify-content: space-between;
                        // grid-template-columns: 50% 50%;
                        // border: 1px solid red;
                        padding: 0px 15px;


                        p {
                            font-family: 'PingFang SC';
                            font-style: normal;
                            font-weight: 400;
                            font-size: 12px;
                            width: 100%;
                            line-height: 22px;
                            // border: 1px solid red;
                            
                            

                            /* 白/FE */

                            // color: rgba(156, 156, 156, 1);

                            &:nth-child(2) {
                                text-align: right;
                            }
                        }


                    }

                    &:nth-child(2) {
                        padding: 5px 15px;
                        font-family: 'PingFang SC';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 16px;
                        line-height: 22px;


                        /* 黄/主题 */

                        // color: #f89b19;
                        color: var(--unnamed, #f89b19);

                    }

                    &:nth-child(3) {
                        padding: 0px 15px 10px 15px;
                        color: #7B7B7B !important;
                    }
                }
            }
        }
    }

}
</style>